import React from "react";
import { Button, Dropdown, Image, Select, Space } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import esFlag from "../../img/es.png";
import caFlag from "../../img/ca.svg";
import plFlag from "../../img/pl.png";
import deFlag from "../../img/de.png";
import ruFlag from "../../img/ru.png";
import frFlag from "../../img/fr.png";
import enFlag from "../../img/gb.png";
import { updateFleetDetails } from "../../services/fleetDetailsFirestore";

const LanguageButton = ({ fleetId, compact = false }) => {
  const { i18n, t } = useTranslation();
  const selectedLanguage = String(i18n.resolvedLanguage || i18n.language || "en")
    .toLowerCase()
    .split("-")[0];

  const languageOptions = [
    { value: "es", label: "Español", flag: esFlag },
    { value: "ca", label: "Català", flag: caFlag },
    { value: "en", label: "English", flag: enFlag },
    { value: "de", label: "Deutsch", flag: deFlag },
    { value: "fr", label: "Français", flag: frFlag },
    { value: "ru", label: "Русский", flag: ruFlag },
    { value: "pl", label: "Polski", flag: plFlag },
  ];
  const currentLanguage = languageOptions.find(option => option.value === selectedLanguage) || languageOptions.find(option => option.value === "en");

  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);

    const languageMap = {
      es: "es-ES",
      ca: "ca-ES",
      en: "en-US",
      de: "de-DE",
      fr: "fr-FR",
      ru: "ru-RU",
      pl: "pl-PL",
    };

    const dbLanguage = languageMap[lng] || lng;

    if (!fleetId) return;

    try {
      await updateFleetDetails(fleetId, { fleetLanguage: dbLanguage });
      console.log(`Idioma actualizado en la base de datos para la flota ${fleetId}: ${lng}`);
    } catch (error) {
      console.error("Error al actualizar el idioma:", error);
    }
  };

  if (compact) return (
    <Dropdown trigger={["click"]} menu={{selectedKeys:[selectedLanguage],onClick:({key})=>changeLanguage(key),items:languageOptions.map(option=>({key:option.value,label:option.label,icon:<Image src={option.flag} alt="" width={18} height={18} preview={false}/>}))}}>
      <Button shape="round" icon={<GlobalOutlined/>} title={t("setup.language")} aria-label={`${t("setup.language")}: ${currentLanguage.label}`}>
        {currentLanguage.label}
      </Button>
    </Dropdown>
  );

  return (
    <Select
      value={selectedLanguage}
      onChange={changeLanguage}
      options={languageOptions.map((option) => ({
        value: option.value,
        label: (
          <Space size={8}>
            <Image
              src={option.flag}
              alt={option.label}
              width={18}
              height={18}
              preview={false}
            />
            <span>{option.label}</span>
          </Space>
        ),
      }))}
      style={{ width: "100%", maxWidth: 260 }}
      optionLabelProp="label"
    />
  );
};

export default LanguageButton;
